import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getAllUsers } from '@/modules/User/gql/user.gql'
import { User } from '@/modules/User/interfaces/user'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchUser extends Vue {
  candidatesUser: User[] = []

  get candidatesUserOptions () {
    return this.candidatesUser.map(item => {
      return {
        id: +item.id,
        name: item.username
      }
    })
  }

  async mounted () {
    await this.getCandidateUsers()
  }

  async getCandidateUsers (val?: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAllUsers,
        variables: {
          nameFilter: val || ''
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesUser = this.$R.sortBy(this.$R.compose(this.$R.toLower, this.$R.prop('username')))(result.data.getAllUsers)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
